import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NotesCard } from 'transfix-ui/components/NotesCard'
import { getNotes, submitNote, submitCallback } from 'utils/actions/notes'
import { useUserDetails } from 'utils/hooks/useUserDetails'

export const Notes = () => {
  const dispatch = useDispatch()
  const dispatchGetNotes = (id, type, noteType) => dispatch(getNotes(id, type, noteType))
  const dispatchSubmitNote = (note, filter) => dispatch(submitNote(note, filter))
  const dispatchSubmitCallback = note => dispatch(submitCallback(note))
  const state = useSelector(({ notes, shipmentData: { shipment } = {} }) => ({
    notes,
    shipment,
  }))
  const {
    notes: { notesAreLoading, notesError, notesList },
    shipment: { id: shipmentId } = {},
  } = state
  const { userDetails } = useUserDetails()

  return (
    <div className='col-xs-12 col-md-12'>
      <NotesCard
        noteableType='Shipment'
        noteableId={shipmentId}
        getNotes={dispatchGetNotes}
        submitNote={dispatchSubmitNote}
        submitCallback={dispatchSubmitCallback}
        notes={notesList}
        userId={userDetails?.id}
        fetching={notesAreLoading}
        error={notesError}
      />
    </div>
  )
}
